import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search, Plus, Download } from 'lucide-react';
import { api } from '@/lib/api';
import CaseDetail from '@/components/CaseDetail';
import NewCaseForm from '@/components/NewCaseForm';

const downloadCsv = async (path, filename) => {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, { credentials: 'include' });
  if (!res.ok) return;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};

export default function Cases({ user }) {
  const [params, setParams] = useSearchParams();
  const [cases, setCases] = useState([]);
  const [q, setQ] = useState('');
  const [type, setType] = useState('');
  const [openId, setOpenId] = useState(null);
  const [showNew, setShowNew] = useState(params.get('new') === '1');

  const load = () => api(`/cases?q=${encodeURIComponent(q)}&case_type=${type}`).then(setCases);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q, type]);

  const closeNew = () => { setShowNew(false); if (params.get('new')) { params.delete('new'); setParams(params); } };
  const onCreated = () => { closeNew(); load(); };

  return (
    <>
      <div className="page-head">
        <div>
          <span className="eyebrow">EMPLOYEE RELATIONS</span>
          <h1>Case register</h1>
          <p className="muted">Review, triage and move every case forward with confidence.</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button data-testid="export-cases-csv" className="secondary-btn" onClick={() => downloadCsv(`/exports/cases.csv?q=${encodeURIComponent(q)}&case_type=${type}`, 'fairway-cases.csv')}>
            <Download size={15} /> Export CSV
          </button>
          <button data-testid="new-case-button" className="primary-btn" onClick={() => setShowNew(true)}>
            <Plus size={17} /> New case
          </button>
        </div>
      </div>
      <div className="toolbar">
        <div className="search-box">
          <Search size={17} />
          <input data-testid="case-search-input" placeholder="Search cases, crew or categories" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
        <select data-testid="case-type-filter" value={type} onChange={(e) => setType(e.target.value)}>
          <option value="">All case types</option>
          <option>Disciplinary</option>
          <option>Grievance</option>
        </select>
      </div>
      <section className="panel case-table">
        <div className="table-head">
          <span>CASE</span><span>TYPE</span><span>SEVERITY</span><span>STATUS</span><span>OPENED</span>
        </div>
        {cases.length === 0 && <div className="empty-inline">No cases match your filters.</div>}
        {cases.map((c) => (
          <button data-testid={`case-row-${c.id}`} className="case-row" key={c.id} onClick={() => setOpenId(c.id)}>
            <div><strong>{c.id}</strong><small>{c.subject} · {c.category}</small></div>
            <span>{c.case_type}</span>
            <span className={`severity ${c.severity.toLowerCase().replace(/\s+/g, '-')}`}>{c.severity}</span>
            <span className={`status ${c.status.toLowerCase().replaceAll(' ', '-')}`}>{c.status}</span>
            <span>{c.opened}</span>
          </button>
        ))}
      </section>
      {openId && <CaseDetail caseId={openId} onClose={() => setOpenId(null)} onChanged={load} />}
      {showNew && <NewCaseForm user={user} onClose={closeNew} onCreated={onCreated} />}
    </>
  );
}
